import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import isString from 'lodash/isString';

@Injectable({
  providedIn: 'root'
})
export class PlasticService
{
  private readonly assetBuilderUrl: string ="https://worker.flora-cms.bgamestudios.com";
  constructor(private http: HttpClient) {}

  async plasticListFiles(path: any)
  {
    let files = [];
    if(path && !isString(path)){
          path = path.path;
    }

     // Remove trailing '/' if it exists
    // if (path && path.endsWith('/')) {
    //   path = path.slice(0, -1);
    // } else {
    //   path = path+"*";
    // }
    path = path+"*";

    if(path)
    {
      let response = await firstValueFrom
      (
        this.http.post<any>(`${this.assetBuilderUrl}/plastic/listfiles`,
        {
          path: 'approved_assets/' + path
        })
      );

      if(response && response.files)
      {
        files = response.files;
      }
    }

    return files;
  }

  async fetchBuildErrorLogs(miscAssetId: number){
    return firstValueFrom(this.http.get<any>(`api/miscellaneous-build/build-error-logs/${miscAssetId}`));
  }

  async fetchBuildErrorLogFile(key: string) {
    return firstValueFrom(
      this.http.get(`api/miscellaneous-build/build-error-logs/file`, {
        params: { key },
        responseType: 'arraybuffer',
      }),
    );
  }
}
